<template lang="pug">
#app
  div.a-view
    //- section1
    div.section.center-content(ref="section1")
      transition(
        enter-active-class="animate__animated animate__fadeIn",
        leave-active-class="animate__animated animate__fadeOut",
      )
        your-choose(option="a")
    //- section2
    div.section(ref="section2")
      transition(
        enter-active-class="animate__animated animate__fadeIn",
        leave-active-class="animate__animated animate__fadeOut",
      )
        mobile-mockup(v-if="sections.section2.isActive", app-name="tg")
          Telegram-page
    //- section3
    div.section-flow(ref="section3")
      div.content
        div.tags(ref="tags")
          span#t.tag 深度報導
          a.share-icon.facebook(href="https://www.facebook.com/sharer/sharer.php?u=https://campaign.theinitium.com/20220331-mainland-digital-sexual-violence/a.html%23t", target="_blank")
          a.share-icon.twitter(href="http://twitter.com/share?url=https://campaign.theinitium.com/20220331-mainland-digital-sexual-violence/a.html%23t&text=如何和中國大陸的警方周旋，又如何在高度隱秘的互聯網中，保留證據，鎖定嫌疑人？", target="_blank")
        p.title 【調查網絡色情群組】艱難維權路：如何抓住「他」？
        p.author 端傳媒記者 卓琳 實習記者 張晉谷
        div.article
          p 2021年初，楊瀟瀟突然被陌生網友告知，Twitter上有人傳播她的私密照片，並公開她的微信賬號，讓網友去「約炮」。楊瀟瀟第一時間去找前男友對質。她記得數年前兩人還在戀愛時，這個男生偷拍過她的裸照，她當時要他刪除了，但此刻裸照還是出現在互聯網上。
          p 「他一直跟我說，對不起我。」
          p 楊瀟瀟選擇了報警，該名男生被警方傳喚前去錄口供。如今她已記不清現場的細節，只記得對方父母趕到派出所不斷懇求她撤案，前男友則是一副知錯模樣。警方沒有立案，也沒有解釋原因，沒有出具《不予立案通知書》，一切戛然而止。
          p 影像性暴力是全球不少女性面臨的困境。近年最轟動案件是韓國「N號房」事件，在2018年至2020年初，有運營者威脅、恐嚇包括未成年人在內的女性拍攝裸照和性剝削影片，並創建不同級別的Telegram群組進行傳播和牟利，最終該案件主犯趙主彬被韓國最高法院判監42年。
          p 然而，這類散播未經同意的私密影像的色情群組並沒有停止。去年12月底開始，中國自媒體和新聞機構發出多篇報道，指出不少女生的生活照、私密照被發到Telegram、Twitter等中國政府封禁的網絡平台，配以淫穢、侮辱的字句，供人「觀賞」、「盯射」。與韓國事件不同的是，暫時未發現有中國女生被強制拍攝或虐待，照片不少是女生身邊熟人，包括丈夫、男友、同學或同事所盜取，或網絡賬號被黑客入侵後泄漏的。
          div.img
            img(src="./../../assets/imgs/news-1-1.jpeg")
            p 2020年3月24日，南韓當局將「N號房」網絡性犯罪案主謀趙主彬由警局移送至檢察官辦公室。
            p 攝：Kim Hong-Ji/Reuters/達志影像
          p 不僅僅在中國，據<a href="https://www.bbc.com/news/world-60303769" target="_blank">BBC</a>、<a href="https://www.scmp.com/week-asia/long-reads/article/3135803/abuse-and-anger-inside-online-groups-spreading-stolen-sexual" target="_blank">SCMP</a>報道，受害的也包括在馬來西亞、俄羅斯、巴西、肯尼亞等至少20個國家的女生，一些群組更散播未成年女生的影像。香港嶺南大學社會學及社會政策系副教授陳效能研究性別議題多年，她對端傳媒表示，性暴力這一概念不僅僅包括強姦等涉及肢體衝突的行為，事實上，任何未經同意的、與性有關的行為都是性暴力。
          p 端傳媒臥底多個色情群組，跟蹤調查兩個多月，採訪多名受訪者。她們被動陷入圍觀和意淫的焦點，在精神上飽受折磨；有人因害怕而選擇沉默，而對於少數像楊瀟瀟一樣主動報警的女生來說，最大的困難在於：如何和中國大陸的警方周旋，又如何在高度隱秘的互聯網中，保留證據，鎖定嫌疑人？
          h3 誰是嫌疑人？
          p 和楊瀟瀟一樣，黃悅同樣被網友告知，有人在Twitter上發了她的生活照，照片上還留有她的微博水印。此前，黃悅從來沒有嘗試過「翻牆」，沒有登錄過Twitter。
          p 在懂得如何翻牆的男友幫助下，黃悅開始觀察發佈她照片的Twitter賬號。她發現，自己每次在微信朋友圈發新照片後，對方就會「盜取」照片發到Twitter，看著對方配上的侮辱性言論，黃悅氣得發抖。
          p 她猜測盜取照片的嫌疑人就在自己微信好友中，卻不能確定是誰。數個月後，黃悅又被陌生網友告知有Twitter賬號發佈了她的生活照。這次她發現，其中一張照片是自己從沒公開過的證件照，而這張照片她只發給過前男友。
          p 儘管感覺已經靠近真相，黃悅卻不敢去對質。在她記憶中，前男友固執偏激，性格比較極端，她生怕對方報復她和自己的家人。她又總覺得這事「不怎麼光彩」，一旦報警，可能會在她老家那個小地方流傳開去。
          p 在微信朋友圈屏蔽前男友之後，黃悅再沒有管這件事。
          p 報警後過了數個月，楊瀟瀟再次被陌生網友通知，她的照片在一個擁有18萬訂閱者的Telegram頻道中洩露了。這一次，她決定自己「翻牆」，註冊了一個Telegram賬號，親自去蒐集更多證據。
          p 順著這個Telegram頻道，她又潛入更多群組。她發現，與Twitter單向發佈照片的賬號不同，Telegram存在著更大量的即時互動群組，大量使用者隱藏在不用曝露真實名字、手機號的隱秘賬號下，不間斷地發佈女生的裸照、生活照，看著大量裸露的女性受害者的照片，楊瀟瀟說，自己震驚得像心臟驟停一樣。
          p 據端傳媒記者觀察，用戶們常常在群組中基於像片和意淫來評價、侮辱女性，發佈照片時，有人會說這是他的熟人，有人說這是來自微信、微博。他們稱呼這些被「獻祭」的女性為「母狗」、「反差婊」、「騷貨」，評價曾與之發生過性關係的女性身材。也有人在群裏發佈女性朋友的姓名和微信賬號，鼓動群友去騷擾對方。
          p 另外，群裏有人發出自己的性器官與電子屏幕上女性大臉照的合影，屏幕上留有他們的精液，稱之為「射屏」，也有網友收費數十元人民幣，替其他網友拍攝自己「射屏」的過程。
          div.img
            img(src="./../../assets/imgs/news-1-2.jpg")
            p Telegram一個色情聊天群組。
          p 為了蒐集證據，楊瀟瀟每天花幾十分鐘去翻閱新的聊天記錄，持續三個多月。
          p 她在群裏找到了5張自己的生活照，還有一些前男友偷拍的私密照。再後來，她發現發佈她照片的賬號其實擁有多個Telegram賬號，如今都已註銷，其中兩個賬號多次提到楊瀟瀟與另一個女生的校名等個人信息，以及該女生的私密照和視頻等。楊瀟瀟訝異地發現，那個女生是前男友的另一任女友。
          p 2021年8月，楊瀟瀟決定再次報警。她聯絡了一名律師，在對方指導下，帶著20多張Telegram群聊的截圖作為證據，律師建議她，起訴的罪名是中國《刑法》中的「傳播淫穢物品」。
          p 但楊瀟瀟表示，警方告知她，這些證據「截圖數量不夠多」，沒有達到認定罪名的標準。最終，她的前男友被處以治安拘留5天，隨後釋放。
          h3 「派出所沒有權限去翻牆核實」
          p 自2013年推出以來，Telegram快速普及化。據統計數據網站Statista在2021年10月發佈的報告，Telegram目前擁有5.5億活躍用戶，在全球最受歡迎的即時通訊軟件中排行第五，位居WhatsApp、Facebook、微信、QQ之後。
          p 這款由俄羅斯程序員杜羅夫兄弟創辦的軟件主打安全性、隱私性和海量群聊，一個群組最多可容納20萬組員，可以在群裏發起投票，同時提供不限成員數量的「頻道（channel）」，關注者可以接收由管理者發佈的任何消息和通知。由於這些特徵，Telegram在「阿拉伯之春」、香港反修例運動等大型社會運動中常常被使用。
          div.img
            img(src="./../../assets/imgs/news-1-3.jpg")
          p 中國大陸稱Telegram為「電報」。據可監測中國防火牆屏蔽情況的GreatFire測試結果，自2015年7月11日開始，Telegram無法在中國大陸使用。當時中國正爆發709維權律師大抓捕事件，7月9日起，遍及24個省級行政區的上百名維權律師、律所成員、民間維權人士和家屬被陸續逮捕、傳喚、拘留、限制出境等。據中國官媒報道，他們的「串聯工具」正是Telegram。
          p 早於2009年，Twitter、Facebook等開始不能在中國大陸使用。由於防火牆的存在，不少當事女性難以在第一時間發現照片在網絡上傳播，而「翻牆」的特殊性又增加了受害者取證的困難，以及對維權可行性的擔憂。
          p 根據中國法律，盜取、搬運他人私密照、生活照並加以意淫和侮辱等，涉及什麼法律？關注女性權益案件的律師李婷（化名）對端傳媒表示，上述行為可能涉及不同罪名。
          p 李婷指，盜取、私自散布女性的生活照並發表侮辱言論的行為是洩露公民個人信息和造謠誹謗的違法行為，受害者可以截圖後報案，要求警方予以治安處罰。根據《刑法》第246條，如果造謠導致誹謗信息實際被點擊、瀏覽次數超過5000次以上，或者轉發超過500次以上，將構成侮辱誹謗罪。
          p 而對於未經同意散布私密影像並發表侮辱文字的行為，李婷表示，這符合《刑法》所規定的強制侮辱罪的特徵及構成條件。
          p 廣東省高級人民法院曾經發佈2018年度涉互聯網十大典型案例中，其中一例涉及「強制侮辱罪」。2017年，楊某華為羞辱、報復某女性，在一個47人的微信群中發送多張她的裸照，並發表 「看看這就是冰兒（女性微信名）」等羞辱性言論。最終，楊某華被認定構成強制侮辱罪，判處有期徒刑一年。
          p 李婷指，中國大陸居民「翻牆」發佈侮辱、誹謗、淫穢信息，仍然構成刑事犯罪或者民事侵權，不過在現實中，對於防火牆外的互聯網行為，派出所的警察沒有權力也缺乏動力去蒐集證據。
          p 「派出所沒有權限去翻牆核實，所以證據越充分詳實越好。」李婷說，因此受害人常常需要自行收集被散布信息的截圖，以及有轉發或者點擊量的截圖，在備好證據後再報警。
          h3 「監獄關不了那麼多」
          p 端傳媒記者觀察，在傳播中國大陸女生照片的色情群組中，一些用戶曾討論信息安全和網絡警察的問題，大多數人對此抱以毫不在乎的態度。
          p 不少用戶認為，警察不會管這類色情社群。「搞黃色無所謂，監獄關不了那麼多人」，「網警連電信詐騙、裸照敲詐勒索那種都管不過來」，「把你叫到警局，告訴你下回不許了，這樣是不對的，然後回家」。
          div.img
            img(src="./../../assets/imgs/news-1-4.png")
            p Telegram一個色情聊天群組，用戶們討論是否有法律風險。
          p 長期活躍並常常發佈內容的用戶警覺性很強，他們通常會隱藏電話號碼，也會利用Google Voice等虛擬電話號碼註冊多個賬號，隨時刪除聊天記錄，若是遇到緊急情況便立即註銷整個賬號。
          p 在其他國家，上述行為也常常陷入無頭公案。2020年10月，馬來西亞的多名女性一起向當地警方集體報案，她們的泳裝照、私密照、社交平台的日常照被發佈在高達3.8萬成員的Telegram V2K 群組內。根據該國的《通信和多媒體法》，只要發佈任何淫穢評論、意圖騷擾他人，無論是否針對裸照，即構成犯罪。
          p 不過，根據報道，馬來西亞通訊及多媒體部在2020至2021年調查了69宗通過社交媒體散布色情信息的案子，最終因缺失證據、內容被刪除、虛假註冊賬號等因素，沒有一個案例被提出控告、罰款或轉交予警方。
          p 根據韓國法律，在N號房事件中，加入聊天室觀看的成員不會被視為施暴者和處以相應懲罰，只有直接生產或傳播性剝削視頻的人才會面臨刑事處罰。此外，Telegram的隱秘性也給韓國警方帶來了取證困難的問題，不時被刪除的聊天記錄和沒有存檔的實時影片難以佐證犯罪行為。
          p 在香港，2021年10月政府剛剛修訂了《刑事罪行條例》，新增了窺淫罪、未經同意下拍攝私密影像等四項罪名，最高刑罰為監禁五年。而在此之前，香港沒有直接針對影像性暴力的法規，同類案件多以性騷擾或發佈淫穢物品罪來起訴。
          p 2020年5月，一名香港註冊專科醫生因在Telegram群組中多次發佈一女子的私密部位影像，被控四項發佈淫穢物品罪，<a href="https://news.mingpao.com/pns/%E6%B8%AF%E8%81%9E/article/20220222/s00002/1645467269155/%E9%86%AB%E7%94%9F%E8%A2%AB%E6%8E%A7tg%E8%B2%BC%E5%A5%B3%E5%AD%90%E6%B7%AB%E7%85%A7-%E4%BA%8B%E4%B8%BB%E4%B8%88%E5%A4%AB%E4%BD%9C%E4%BE%9B%E5%93%BD%E5%92%BD" target="_blank">案件近日正在審訊</a>。
          p 不過，陳效能指，目前香港的上述罪行主要針對涉私密部位的影像，如果只發佈生活照、同時以文字進行侮辱，可能難以在法律上定罪。
          p 香港關注婦女性暴力協會從去年2月1日開始推出「Ta-DA下架支援」項目，協助被散播私密影像的受害者與網絡平台溝通，以移除照片。協會倡議主任簡敏棋向端傳媒表示，截止2021年底，項目共收到238條包含未經同意私密影像的網絡連結，經溝通後，179個連結被移除。她指出，協會常收到涉及Telegram的求助，但Telegram一般不會回應移除內容的請求。
          p 此外，簡敏棋表示，罪行的認定還需要看發佈者的意圖。由於群組牽涉到很多成員，很難證明他們是要故意侮辱當事人，因此很難去控告整個Telegram群組。她還提及，大部分求助Ta-DA支援的受害者並不知道發佈者是誰，這也是她們選擇不報警的一個原因——很多受害者能預想到，無法確認發佈者的案件辦理難度，往往會放棄。
          p 斯坦福大學網絡觀察中心（Internet Obervatory）的首席技術官員David Thie接受《南華早報》訪問時指出，和大眾印象不同，Telegram其實不是一個加密軟件，它的個人聊天和群組聊天都是非加密的（unencrypted），意味著Telegram可以拿到這些聊天內容並加以監管。端傳媒記者曾多次就此問題填寫Telegram客戶反饋表，以及致信其CEO查詢，至截稿前均未獲得回覆。
          p 此前，Telegram拒絕了BBC的採訪要求，但在回應的聲明中表示，會主動監視公共空間、處理用戶對違反其服務條款內容的舉報。不過，Telegram並沒有證實其是否允許未經同意發佈他人的私密圖片，也沒有確認這些圖片是否被刪除。
          p 端傳媒向Twitter亞太地區的政策傳播團隊致信，其發言人表示，在未經同意的情況下分享某人明確的性圖像或影片是對其隱私和Twitter規則的嚴重侵犯，另外，Twitter對任何以兒童性剝削為特徵或宣傳的材料絕對零容忍。
          p 該發言人還表示，Twitter有明確的規則來處理未經同意的裸照、私人信息和兒童性剝削等信息，在技術方面進行了大量投資，通過人工和科技相結合、全天候審查並回應用戶舉報。不過，雖然Twitter為用戶提供了舉報通道，但數量巨大且未經同意發佈的私密照片無法根除。
          p 楊瀟瀟發現，前男友結束拘留之後，還在Twitter上點讚了散播楊瀟瀟照片的推文。她將這個情況告訴警察，警察說「會問清楚」，但後來再沒有聯繫過她。
          p 「其實我已經是非常幸運的了，我已經是目前能做到最好的人了。」楊瀟瀟這麼覺得。據她所知，她是少有的報警成功且讓對方得到一定懲處的人，但她還是會害怕。有時走在路上，她會很擔心，被其他人認出自己來。
          p （為尊重受訪者意願，文中楊瀟瀟、黃悅、李婷為化名。）
      transition(
        enter-active-class="animate__animated animate__fadeInUp animate__fast",
        leave-active-class="animate__animated animate__fadeOutDown animate__fast",
      )
        other-news(v-if="sections.section3.isActive")
</template>

<script>
import imagesloaded from 'imagesloaded'
import MobileMockup from '@/components/MobileMockup'
import YourChoose from '@/components/YourChoose'
import TelegramPage from './TelegramPage'
import OtherNews from '@/components/OtherNews'

const ScrollMagic = window.ScrollMagic

export default {
  name: 'AView',
  components: {
    MobileMockup,
    YourChoose,
    TelegramPage,
    OtherNews
  },
  data () {
    return {
      sections: {
        section1: {
          isActive: false
        },
        section2: {
          isActive: false
        },
        section3: {
          isActive: false
        }
      }
    }
  },
  methods: {
    initScrollMagic () {
      const controller = new ScrollMagic.Controller()

      Object.keys(this.sections).forEach(sectionName => {
        new ScrollMagic.Scene({
          triggerElement: this.$refs[sectionName],
          triggerHook: 0.5,
          duration: this.$refs[sectionName].clientHeight
        })
          .on('enter', () => {
            this.sections[sectionName].isActive = true
          })
          .on('leave', () => {
            this.sections[sectionName].isActive = false
          })
          // .addIndicators()
          .addTo(controller)
      })
    }
  },
  mounted () {
    imagesloaded(this.$refs.section3, () => {
      this.initScrollMagic()
    })

    if (location.hash === '#t') {
      this.$refs.tags.scrollIntoView()
    }
  }
}
</script>

<style lang="scss" scoped>
.a-view {
  background-color: transparent;
  background-image:
  linear-gradient(0deg, transparent 9%,
    rgba(255, 255, 255, .1) 10%, rgba(255, 255, 255, .1) 12%, transparent 13%, transparent 29%,
    rgba(255, 255, 255, .05) 30%, rgba(255, 255, 255, .05) 31%, transparent 32%, transparent 49%,
    rgba(255, 255, 255, .05) 50%, rgba(255, 255, 255, .05) 51%, transparent 52%, transparent 69%,
    rgba(255, 255, 255, .05) 70%, rgba(255, 255, 255, .05) 71%, transparent 72%, transparent 89%,
    rgba(255, 255, 255, .05) 90%, rgba(255, 255, 255, .05) 91%, transparent 92%, transparent),
  linear-gradient(90deg, transparent 9%,
    rgba(255, 255, 255, .1) 10%, rgba(255, 255, 255, .1) 12%, transparent 13%, transparent 29%,
    rgba(255, 255, 255, .05) 30%, rgba(255, 255, 255, .05) 31%, transparent 32%, transparent 49%,
    rgba(255, 255, 255, .05) 50%, rgba(255, 255, 255, .05) 51%, transparent 52%, transparent 69%,
    rgba(255, 255, 255, .05) 70%, rgba(255, 255, 255, .05) 71%, transparent 72%, transparent 89%,
    rgba(255, 255, 255, .05) 90%, rgba(255, 255, 255, .05) 91%, transparent 92%, transparent);
  height:100%;
  background-size:50px 50px;
}
.section {
  height: 90vh;
  @media (max-width: 960px) {
    overflow: hidden;
  }
  &.center-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mobile-mockup {
    position: fixed;
    bottom: 0;
    left: 48%;
    transform: translateX(-50%);
    @media (max-width: 960px) {
      transform: translate3d(-58%, 20px, 0);
    }
  }
}
</style>
